import styled from 'styled-components'
import { Button, Form } from '@sketch/components'

export const StyledForm = styled(Form)`
  display: flex;
  align-items: flex-end;
  width: 100%;
`

export const SubmitButton = styled(Button)`
  margin-left: 16px;
  margin-bottom: 6px; /* stylelint-disable-line scales/space */
`

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
